import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Flex, Text, HStack, Icon, Badge } from '@chakra-ui/react';
import { FiMapPin, FiActivity } from 'react-icons/fi';
import { useOrgLocation } from '@/context/organization-location-context';

export const DashboardWrapper = (props: { children: React.ReactNode }) => {
  const { selectedOrganisation, selectedLocation } = useOrgLocation();
  const navigate = useNavigate();

  // If in the wrapper but no selections, we need to redirect
  React.useEffect(() => {
    if (!selectedOrganisation) {
      navigate('/organisation-selection');
    } else if (!selectedLocation) {
      navigate('/location-selection');
    }
  }, [selectedOrganisation, selectedLocation, navigate]);

  // Render the wrapped dashboard
  return (
    <Box>
      {/* Selection information banner */}
      <Flex
        bg="blue.50"
        p={3}
        borderRadius="md"
        mb={4}
        alignItems="center"
        justifyContent="space-between"
      >
        <HStack gap={6}>
          <HStack>
            <Icon as={FiActivity} color="blue.500" />
            <Text fontWeight="medium">Organization:</Text>
            <Badge size="md" colorPalette="blue">
              {selectedOrganisation?.name}
            </Badge>
          </HStack>

          <HStack>
            <Icon as={FiMapPin} color="green.500" />
            <Text fontWeight="medium">Location:</Text>
            <Badge size="md" colorPalette="green">
              {selectedLocation?.name}
            </Badge>
          </HStack>
        </HStack>

        <Text fontSize="sm" color="gray.500">
          All data shown is filtered for this organization and location
        </Text>
      </Flex>

      {props.children}
    </Box>
  );
};
